import React from 'react';
import './AnalyticsSection.css';
import { motion } from 'framer-motion';

const AnalyticsSection = () => {
  const features = [
    {
      id: 'leaderboard',
      title: "Smart",
      highlight: "Leaderboard",
      position: "left-bottom",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
          <path d="M9 12h6"></path><path d="M9 16h6"></path><path d="M9 8h6"></path>
        </svg>
      )
    },
    {
      id: 'quiz',
      title: "Track Your",
      highlight: "progress via Quiz",
      position: "left-top",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21h6"></path><path d="M9 17h6"></path>
          <path d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7z"></path>
        </svg>
      )
    },
    {
      id: 'reminders',
      title: "Time to time",
      highlight: "Reminders",
      position: "right-top",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
          <circle cx="12" cy="14" r="2"></circle>
        </svg>
      )
    },
    {
      id: 'course',
      title: "Track your",
      highlight: "Course",
      position: "right-bottom",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line>
          <line x1="6" y1="20" x2="6" y2="14"></line>
        </svg>
      )
    }
  ];

  return (
    <section className="ucp-section ucp-analytics">
      <div className="analytics-bg-grid"></div>
      
      <div className="analytics-container">
        <div className="analytics-arc-wrapper">
          {/* Central Arc */}
          <div className="central-arc">
             <div className="arc-line"></div>
          </div>

          {/* Center Content */}
          <div className="center-text">
            <motion.h2 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              Analytics
            </motion.h2>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.3 }}
            >
              Empower your coding journey with analytics-driven courses
            </motion.p>
          </div>

          {/* Feature Points */}
          {features.map((feature, index) => (
            <div key={feature.id} className={`feature-point ${feature.position}`}>
              <motion.div 
                className="feature-label"
                initial={{ opacity: 0, x: feature.position.includes('left') ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <div className="dashed-line-connector"></div>
                <div className="label-content">
                  <span className="title-part">{feature.title}</span>
                  <span className="highlight-part">{feature.highlight}</span>
                </div>
              </motion.div>

              <motion.div 
                className="feature-icon-wrapper"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 100, delay: index * 0.2 }}
              >
                <div className="icon-circle">
                  {feature.icon}
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AnalyticsSection;
